/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Disabled_Process_Documents_TooltipInputs */

const en_case_create_disabled_process_documents_tooltip = /** @type {(inputs: Case_Create_Disabled_Process_Documents_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process the documents before creating the case.`)
};

const pt_br2_case_create_disabled_process_documents_tooltip = /** @type {(inputs: Case_Create_Disabled_Process_Documents_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processe os documentos antes de criar o caso.`)
};

/**
* | output |
* | --- |
* | "Process the documents before creating the case." |
*
* @param {Case_Create_Disabled_Process_Documents_TooltipInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_disabled_process_documents_tooltip = /** @type {((inputs?: Case_Create_Disabled_Process_Documents_TooltipInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Disabled_Process_Documents_TooltipInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_disabled_process_documents_tooltip(inputs)
	return pt_br2_case_create_disabled_process_documents_tooltip(inputs)
});